import { Injectable, inject } from '@angular/core';
import {CommonTokenStorage} from "./common-token-storage.service";

@Injectable({
  providedIn: 'root'
})
export class TranslationService {

  protected tokenStorage: CommonTokenStorage = inject(CommonTokenStorage);

  getDataFromTranslations(item: any, key: string, lang: string = ''): any {
    if (!item?.translations || !Array.isArray(item.translations)) {
      return '';
    }
    const currentLanguage = this.tokenStorage.getCurrentLanguage() || lang || '';

    const translation = item.translations.find((translation: any) => translation?.lang === currentLanguage);

    return translation?.[key] ?? item?.[key] ?? '';
  }

  getTranslationData(data: any) {
    let translationData = JSON.parse(JSON.stringify(data, (key, value) => {
      let retVal = value;
      if (key === 'translations') {
        retVal = {};
        for (let i = 0; i < value.length; i++) {
          retVal[value[i].lang] = value[i];
        }
      }
      return retVal;
    }));

    return translationData;
  }
}
